import { defineMessages } from 'react-intl';

export default defineMessages({
  quantity: {
    id: 'components.ProductLayout.title',
    defaultMessage: 'Quantity',
  },
  addToCart: {
    id: 'components.ProductLayout.addToCart',
    defaultMessage: 'ADD TO SHOPPING CART',
  },
  giftCardInformation: {
    id: 'pricing.giftCard.Process',
    defaultMessage:
      'Once your order is complete, the gift card will immediately be sent to the recipient email address. You can also send it to your own email address, if you’d prefer to share the code with the recipient later.',
  },
  availableImmediately: {
    id: 'pricing.giftCard.availability',
    defaultMessage: 'Available immediately',
  },
  notAvailableYet: {
    id: 'pricing.giftCard.messageTerritory',
    defaultMessage:
      'Sorry, Gift Cards are not yet available in your territory.',
  },
});
